import * as Yup from "yup";

import { Strings } from "@app/constants";

export const addBrandSchema = Yup.object()
  .shape({
    carBrandName: Yup.string().required(
      Strings.validation.fieldRequired(Strings.dashboard.name)
    ),
  })
  .required();
